
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ILoginCredentials, IForm, IValidations } from '@/interfaces';
import { FormMixinComponent } from '@/mixins';
import { LoginValidator } from '@/validators';

import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';
import Btn from '@/components/Btn.vue';
import Splitter from '@/components/Splitter.vue';

@Component({
  name: 'login-form',
  components: { Field, TextField, Btn, Splitter },
  mixins: [ FormMixinComponent ]
})
export default class LoginFormComponent extends Vue implements IForm<ILoginCredentials> {
  /**
   * To determine if this form is loading or not
   */
  @Prop({ type: Boolean, default: false }) public loading!: boolean;

  /**
   * The saved validations so we can show them if needed
   */
  public validations: IValidations<ILoginCredentials> | null = null;

  /**
   * The validator we should use when checking validations
   */
  public validator = new LoginValidator();

  /**
   * The user we are creating
   */
  public model: ILoginCredentials = { userEmail: '', password: '' };
}
